const SERVER_IP = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace("/api/v1", "").replace(/^https?:\/\//, "")
  : `localhost:3978`;

const PROTOCOL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.split("://")[0] + ":"
  : window.location.protocol;

export function getUploadUrl(filename) {
  if (!filename) return null;
  const clean = filename.replace(/^uploads\//, "");
  return `${PROTOCOL}//${SERVER_IP}/uploads/${clean}`;
}

export const ENV = {
  BASE_PATH: `${PROTOCOL}//${SERVER_IP}`,
  BASE_API: process.env.REACT_APP_API_URL || `${PROTOCOL}//${SERVER_IP}/api/v1`,
  API_ROUTES: {
    REGISTER: "auth/register",
    LOGIN: "auth/login",
    REFRESH_ACCESS_TOKEN: "auth/refresh_access_token",
    USER_ME: "user/me",
    USER: "user",
    USERS: "user",
    MENU: "menu",
    PORTADA: "portada",
    GESTIONHUMANA: "gestion",
    DOCUMENTO_ME: "documento/me",
    DOCUMENTO: "documento",
    DOCUMENTOS: "documentos",
    NOTA: "nota",
    NOTAS: "notas",
    CONTACTANOS: "contactanos",
    NEWSLETTER: "newsletter",
    POST: "post",
    ENVIO_CORREO: "correo",
    PERFILES_PUESTO: "perfiles-puesto",
    PERFILES_PUESTO_EXTRAER_PDF: "perfiles-puesto/extraer-pdf",
    PERFILES_PUESTO_GENERAR_MARKDOWN: "perfiles-puesto/generar-markdown",
    VACANTES: "vacantes",
    VACANTES_NOTIFICAR: "vacantes",
    TESTIMONIOS: "testimonios",
    CORREO_DESTINATARIOS: "correo/destinatarios",
    PLANTILLAS: "plantillas",
    SUSCRIPTORES: "suscriptores",
    NOTICIAS: "noticias",
    CITAS: "citas",
    PRODUCTOS: "productos",
    SOCIOS_COMERCIALES: "socios-comerciales",
    DOCUMENTO_EXTRACT_CV_ADMIN: "documento/extract-cv-admin",
    DOCUMENTO_CREATE_ADMIN:     "documento/create-admin",
    DOCUMENTO_CHECK_DUPLICATE:  "documento/check-duplicate",
  },
  JWT: {
    ACCESS_TOKEN: "accessToken",
    REFRESH_TOKEN: "refreshToken",
  },
};
